module.exports = __webpack_public_path__ + "static/media/accesorios.77d15796.png";